export default __webpack_public_path__ + "static/media/H_L_PDF_V3.af7370eb.jpg";